import {time} from '../ladmin/utils'

const placeholder = 'N/A'

const actionHeader = {text: '', value: '', align: 'right', width: '80px', sortable: false}
let t = function (v) {
  return time.stringify(v)
}
export const RULE_HEADERS = [
  {text: '开始时间', value: 'startDatetime', align: 'left', placeholder, f: t, sortable: false},
  {text: '结束时间', value: 'endDatetime', align: 'right', placeholder, f: t, sortable: false},
  {text: '规则类型', value: 'type', align: 'right', placeholder, f: t, sortable: false},
  {text: '创建时间', value: 'creationTime', align: 'right', placeholder, f: t},
]
export const SPECIFIC_HEADERS = [
  {text: '开始时间', value: 'startDatetime', align: 'left', placeholder, f: t, sortable: false},
  {text: '结束时间', value: 'endDatetime', align: 'right', placeholder, f: t, sortable: false},
  {text: '规则类型', value: 'type', align: 'right', placeholder, f: t, sortable: false},
  {text: '创建时间', value: 'creationTime', align: 'right', placeholder, f: t},
]
export const RULE_ACTION_HEADERS = [
  ...RULE_HEADERS,
  actionHeader
]
export const SPECIFIC_ACTION_HEADERS = [
  ...SPECIFIC_HEADERS,
  actionHeader
]

export default {
  RULE_HEADERS,
  RULE_ACTION_HEADERS,
  SPECIFIC_HEADERS,
  SPECIFIC_ACTION_HEADERS
}
